import PermMediaOutlined from "@mui/icons-material/PermMediaOutlined";
import type { IconButtonProps } from "@mui/material";
import type { FC } from "react";
import { useDialog } from "../../../../../utils/hooks/use-dialog";
import { FromContentLibraryModal } from "./from-content-library-modal";
import type { ToolbarProps } from "./props";
import { ToolbarIconButton } from "./toolbar-icon-button";

interface FromContentLibraryButtonProps extends IconButtonProps {
  label?: string;
  onClose?: () => void;
}

export const FromContentLibraryButton: FC<ToolbarProps & FromContentLibraryButtonProps> = ({
  disabled,
  label,
  onClose,
}) => {
  const dialog = useDialog();

  return (
    <>
      <ToolbarIconButton
        data-analytics-id="lexical-toolbar-from-content-library"
        disabled={disabled}
        label={label}
        icon={<PermMediaOutlined fontSize="medium" />}
        data-testid="toolbar-button-from-content-library"
        aria-label="from-content-library"
        tabIndex={-1}
        onClick={dialog.handleOpen}
      />
      <FromContentLibraryModal
        open={dialog.open}
        onClose={() => {
          onClose?.();
          dialog.handleClose();
        }}
      />
    </>
  );
};
